<template>
  <transition mode="out-in" name="fade">
    <div
      v-show="active"
      class="w-full rounded-md border border-ontick-steel-300 bg-gray-50 p-4 shadow dark:border-ontick-graphite-500 dark:bg-ontick-graphite-500"
    >
      <div class="flex animate-pulse space-x-4">
        <!-- <div class="rounded-full bg-ontick-steel-100 h-12 w-12"></div> -->
        <div class="flex-1 space-y-4">
          <div
            class="h-4 w-3/4 rounded bg-ontick-steel-100 dark:bg-ontick-steel-500"
          ></div>
          <div class="space-y-2">
            <div
              class="h-4 rounded bg-ontick-steel-100 dark:bg-ontick-steel-500"
            ></div>
            <template v-for="(item, index) in qtd">
              <div
                class="h-4 w-5/6 rounded bg-ontick-steel-100 dark:bg-ontick-steel-500"
              ></div>
              <div
                class="h-4 w-3/4 rounded bg-ontick-steel-100 dark:bg-ontick-steel-500"
              ></div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "placeholder-card",

  props: {
    qtd: {
      type: Number,
      default: 5,
    },
    active: { default: true },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
